import { Button, Calendar, Col, Form, message, Row, Spin } from "antd";
import React, { Fragment, useEffect } from "react";
import { InputField, ReactSelectField } from "../../../../../atoms/FormElement";
import { getInputPlaceholderMessage } from "../../../../../libs/form";
import { useForm } from "react-hook-form";
import { PatchBankDetailsPayload, usePatch } from "./hook/usePatchBankDetails";
import { useSelector } from "react-redux";
import { propertyService } from "../../../../../../configs/constants";
import { BankDetailsForm, useInitializeBankDetail } from "./hook/useInitializeBankDetail";

interface IProps {}

/**
 * @author
 * @function @
 **/

const EditBankDetails = (props) => {
  const { bankDetails, onClose, onSubmit, bankList } = props;
  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
    setValue,
    setError,
  } = useForm<BankDetailsForm>();
  const { patchData, loading, error } = usePatch<PatchBankDetailsPayload>();
  const form = useForm<BankDetailsForm>();
  console.log(bankDetails, "bankDetails");
  useInitializeBankDetail(setValue, bankDetails,bankList);
  const tenantData = useSelector((state: any) => state.tenantsSummary.tenantData?.userDetail);
  const updateBank = async (data) => {
    const payload = {
      bankDetails: {
        bankName: data.bankName?.value,
        accountHolderName: data.accountHolderName,
        accountNo: data.accountNo,
        iban: data.iban,
      },
    };
    const url = `${propertyService}/tenant/${tenantData.userId}/bank-details`;
    const result = await patchData(url, payload);
    if (result) {
      onSubmit();
      onClose();
      message.success("Bank detail updated sucessfully");
    }
  };
  return (
    <Form layout="vertical" onFinish={handleSubmit(updateBank)}>
      {loading && !error && (
        <Row gutter={[24, 24]}>
          <Col span={24}>
            {/* <Space size={24} direction="vertical"> */}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "35vh" }}>
              <div>
                <Spin size="large" className="ag-fontSize32" />
              </div>
            </div>
            {/* </Space> */}
          </Col>
        </Row>
      )}

      {!loading && (
        <>
          <Row gutter={[24, 24]}>
            <Col span={12}>
              <ReactSelectField
                control={control}
                label="BANK NAME"
                // initValue={item?.bankName}
                selectOption={bankList || []}
                fieldname={`bankName`}
                // validate={errors[`bankName-${index}`] && "error"}
                placeholder={"Bank"}
                // iProps={{
                //   isDisabled: item?.modeOfPayment === "cash",
                // }}
              />
             
            </Col>

            <Col span={12}>
              <InputField
                // isRequired={item?.rules?.required ? true : false}
                control={control}
                label={"Account Name"}
                fieldname={`accountHolderName`}
                // validate={errors[`kyc-${item.name}`] && "error"}
                setValue={setValue}
                iProps={{ placeholder: getInputPlaceholderMessage("Account Name") }}
                //   initValue={kycInitValue(item.name, userKycInfo)}
                //   valueGot={kycInitValue(item.name, userKycInfo)}
              />
            </Col>

            <Col span={12}>
              <InputField
                // isRequired={item?.rules?.required ? true : false}
                control={control}
                label={"Account No"}
                fieldname={`accountNo`}
                // validate={errors[`kyc-${item.name}`] && "error"}
                setValue={setValue}
                iProps={{ placeholder: getInputPlaceholderMessage("Account No") }}
                //   initValue={kycInitValue(item.name, userKycInfo)}
                //   valueGot={kycInitValue(item.name, userKycInfo)}
              />
            </Col>

            <Col span={12}>
              <InputField
                // isRequired={item?.rules?.required ? true : false}
                control={control}
                label={"IBAN"}
                fieldname={`iban`}
                // validate={errors[`kyc-${item.name}`] && "error"}
                setValue={setValue}
                iProps={{ placeholder: getInputPlaceholderMessage("IBAN") }}
                //   initValue={kycInitValue(item.name, userKycInfo)}
                //   valueGot={kycInitValue(item.name, userKycInfo)}
              />
            </Col>
          </Row>
          <Row gutter={24} justify="space-between" style={{ marginTop: "20px" }}>
            <Col>
              <Button
                className="ag-gray-button-outline theme_grey_btn"
                htmlType="button"
                onClick={() => {
                  props.onCancel();
                }}
              >
                Back
              </Button>
            </Col>
            <Col>
              <Button className="ag-green-button theme_btn" htmlType="submit">
                {"Update"}
              </Button>
            </Col>
          </Row>
        </>
      )}
    </Form>
  );
};

export default React.memo(EditBankDetails);
